import { DocumentBody } from "./DocumentBody";
import documents from "./registration-documents.json";

export function PrivacyPolicyBody() {
  const policy = documents.find(document => document.id === "privacy");
  return policy ? <DocumentBody blocks={policy.blocks} /> : null;
}
